import React from "react";

import { motion } from 'framer-motion';
const ResiForm = () => {
     
    const slideInLeft = {
        hidden: { opacity: 0, x: -100 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
    };
    return(
        <motion.div
        className="bg-secondary text-primary p-8 md:p-12  rounded-t-xl shadow-[inset_0px_-8px_25px_0px_rgba(0,0,0,0.25)] flex flex-col gap-6 w-full "
        variants={slideInLeft}
    >
        <h2 className="text-3xl md:text-4xl font-playfair-display text-primary">
            Commercial Inquiry
        </h2>
        <form className="flex flex-col gap-4">
            <motion.input
                type="text"
                placeholder="Your Name"
                className="p-4 rounded-md bg-accent placeholder-primary font-nunito-sans focus:outline-none"
                whileFocus={{ scale: 1.05 }}
            />
            <motion.input
                type="email"
                placeholder="Phone Number"
                className="p-4 rounded-md bg-accent placeholder-primary font-nunito-sans focus:outline-none"
                whileFocus={{ scale: 1.05 }}
            />
            <motion.input
            disabled
                placeholder="Residential"
                className="p-4 rounded-md bg-accent placeholder-primary font-nunito-sans focus:outline-none"
                whileFocus={{ scale: 1.05 }}
            >
              
            </motion.input>
            <motion.textarea
                placeholder="Your Message"
                rows="4"
                className="p-4 rounded-md bg-accent placeholder-primary font-nunito-sans focus:outline-none"
                whileFocus={{ scale: 1.05 }}
            ></motion.textarea>
            {/* Upload File Option */}
            <motion.input
                type="file"
                className="p-4 rounded-md bg-accent placeholder-primary font-nunito-sans focus:outline-none"
                whileFocus={{ scale: 1.05 }}
            />
            <motion.button
                type="submit"
                className="px-6 py-3 bg-primary text-accent rounded-md font-nunito-sans text-lg hover:bg-secondary transition"
                whileHover={{ scale: 1.1 }}
            >
                Send Message
            </motion.button>
        </form>
        {/* Phone Number and Call Button */}
        <div className="flex flex-col gap-4 mt-6">
            <p className="text-lg font-nunito-sans text-primary">
                Or call us directly at:
            </p>
            <motion.a
                href="tel:+1234567890"
                className="px-6 py-3 bg-primary text-accent rounded-md font-nunito-sans text-lg hover:bg-accent transition text-center"
                whileHover={{ scale: 1.1 }}
            >
                Call Us: +1 (234) 567-890
            </motion.a>
        </div>
    </motion.div>
    )
}
export default ResiForm;